import { component } from "picoapp";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";

// import './component.scss';

gsap.registerPlugin(ScrollTrigger);

function Technology({ node, ctx }) {
  useEffect(() => {
    var TechTl = gsap.timeline({
      scrollTrigger: {
        trigger: ".tech-container",
        start: "center 80%",
        end: "center 65%",
        scrub: 1,
      },
    });
    var labelTl1 = gsap.timeline({
      scrollTrigger: {
        trigger: ".tech-container",
        start: "center 70%",
        end: "center 60%",
        scrub: 1,
      },
    });
    var labelTl2 = gsap.timeline({
      scrollTrigger: {
        trigger: ".tech-container",
        start: "center 55%",
        end: "center 45%",
        scrub: 1,
      },
    });
    TechTl.to(".formulaX-adapter", {
      x: "60px",
      y: "-150px",
    });
    TechTl.to(".formulaX-top", {
      y: "-50px",
    });
    TechTl.to(".formulaX-bottom", {
      y: "50px",
    });
    TechTl.to(".formulaX-face", {
      x: "100px",
    });
    labelTl1.fromTo(
      ".tech-spec.first",
      {
        opacity: 0,
      },
      { opacity: 1 }
    );
    labelTl2.fromTo(
      ".tech-spec.second",
      {
        opacity: 0,
      },
      { opacity: 1 }
    );
  }, []);
  return (
    <div className="tech-container">
      <img
        className="formula-block formulaX-adapter"
        src="https://cdn.shopify.com/s/files/1/0675/4441/6494/files/formulaX-adapter.png?v=1706727916"
      />
      <img
        className="formula-block formulaX-top"
        src="https://cdn.shopify.com/s/files/1/0675/4441/6494/files/formulaX-top.png?v=1706727916"
      />
      <img
        className="formula-block formulaX-bottom"
        src="https://cdn.shopify.com/s/files/1/0675/4441/6494/files/formulaX-bottom.png?v=1706727916"
      />
      <img
        className="formula-block formulaX-face"
        src="https://cdn.shopify.com/s/files/1/0675/4441/6494/files/formulaX-face.png?v=1706727916"
      />
      <img
        className="formula-block tech-spec tech-spec-stabilizer first"
        src="https://cdn.shopify.com/s/files/1/0675/4441/6494/files/tech-label-stabilizers.png?v=1708983691"
      />
      <img
        className="formula-block tech-spec tech-spec-louvers second"
        src="https://cdn.shopify.com/s/files/1/0675/4441/6494/files/tech-label-louvers.png?v=1708983691"
      />
      <img
        className="formula-block tech-spec tech-spec-adapter first"
        src="https://cdn.shopify.com/s/files/1/0675/4441/6494/files/tech-label-adapter.png?v=1708983691"
      />
      <img
        className="formula-block tech-spec tech-spec-face second"
        src="https://cdn.shopify.com/s/files/1/0675/4441/6494/files/tech-label-face.png?v=1708983692"
      />
      <img
        className="formula-block tech-spec tech-spec-sole second"
        src="https://cdn.shopify.com/s/files/1/0675/4441/6494/files/tech-label-sole.png?v=1708983692"
      />
      <img
        className="formula-block tech-spec tech-spec-crown first "
        src="https://cdn.shopify.com/s/files/1/0675/4441/6494/files/tech-label-crown.png?v=1708983691"
      />
    </div>
  );
}

// module.exports = Slider;
export default component((node, ctx) => {
  const element = <Technology node={node} ctx={ctx} />;
  const root = createRoot(node);
  root.render(element);

  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
